import React, { useEffect, useMemo, useState } from "react";
import "./CheckOut.css"
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useCreatePaymentMutation } from "../../../Redux/Api/AuthApi";
import useAuth from "../../../MiddleWay/useAuth";

const CheckOut = () => {
  const dispatch = useDispatch();
  const {id} = useAuth()
  const {membershipPlan} = useSelector((state)=>state.Auth)
  const navigate = useNavigate();
  const [Data,setData] = useState([])
  const [createPayment, { isLoading }] = useCreatePaymentMutation();

  // Local state
  const [taxRate] = useState(0.03); // 3% tax

  // Controlled form data
  const [formData, setFormData] = useState({
    email: "",
    emailChecked: false,
    shipping_method: "standard",
    payment_method: "", // "card" or "momo"
  });


  const price = Number(membershipPlan?.price?.slice(1,3)) 
  const childCount = Number(membershipPlan?.childCount)
  const amount = price * childCount

  // Derived totals
  const taxAmount = useMemo(
    () => amount * taxRate,
    [amount,taxRate]
  );
  const total = useMemo(
    () =>
      Number(amount || 0) +
      Number(taxAmount || 0),
    [amount,taxAmount]
  );


  // Generic change handler (handles text, checkbox, radio)
  const handleFormChange = (e) => {
    const { name, type, value, checked } = e.target;
    if (type === "checkbox") {
      setFormData((prev) => ({ ...prev, [name]: checked }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  Data?.push(membershipPlan)


  // Submit handler
  const handlePaymentSubmit = async (e) => {
    e.preventDefault();

    // Basic validation

    const sendData = {
      email:formData?.email,
      emailChecked: formData?.emailChecked,
      payment_method: formData?.payment_method,
      childCount,
      estematedAmount: amount,
      price,
      taxAmount,
      totalAmount:total,
      userId:id,
      planName: membershipPlan?.name,
      planId:membershipPlan?.id
    }

    if (!formData?.payment_method) {
      alert("Please select a payment method.");
      return;
    }


    try {
      if (formData?.payment_method === "card") {
        const response = await createPayment({ sendData});
        const { pesResponse, subData } = response?.data?.data
      //  handle response shape defensively
       if (pesResponse?.redirect_url) {
         // dispatch(finalOrder(JSON.stringify(orderData)));
        // redirect to pesapal url
          window.location.href = pesResponse?.redirect_url;
          return;
        }
      //  fallback
        console.log("Payment response:", response);
        alert("Payment initialization returned no redirect URL.");
      } else if (formData?.payment_method === "momo") {
     //   Example flow for momo: you'd normally call an endpoint to push payment
      //  We'll still send orderObject but you should implement backend momo flow
        const response = await createPayment({ formData, id});// adjust if API differs
        console.log("MOMO init response:", response);
       //  navigate or show message depending on API
        alert("MOMO payment flow initiated. Follow instructions.");
      } else {
        alert("Unknown payment method");
      }
    } catch (err) {
      console.log(err);
      alert("Payment error. Check console.");
    }
  };

  return (
    <div className="bone-checkout-container">
      <header className="bone-checkout-header">
        <div className="bone-checkout-logo">
          <img src="/images/logo2.png" alt="bone-logo" />
        </div>
      </header>

      <main className="bone-checkout-main">
        {/* LEFT: Form */}
        <section className="bone-checkout-form">
          <form onSubmit={handlePaymentSubmit} className="checkout-form-inner">
            {/* Contact */}
            <div className="form-section">
              <div className="section-header">
                <h3>Contact</h3>
                <button
                  type="button"
                  className="signin-link"
                  onClick={() => navigate("/login")}
                >
                  Sign in
                </button>
              </div>

              <label className="input-label">
                Email or phone
                <input
                  name="email"
                  type="text"
                  placeholder="email or phone number"
                  value={formData?.email}
                  onChange={handleFormChange}
                />
              </label>

              <label className="checkbox-label">
                <input
                  type="checkbox"
                  name="emailChecked"
                  checked={formData?.emailChecked}
                  onChange={handleFormChange}
                />
                <span>Email me with news and offers</span>
              </label>
            </div>

            {/* Delivery */}
            <div className="form-section">
              <div className="section-header">
                <h3>Booked By</h3>
              </div>

              <label className="input-label">
                Parent email
                <input
                  name="parent"
                  type="text"
                  placeholder="ex: John@example.com"
                  value={formData?.email}
                  onChange={handleFormChange}
                  required
                />
              </label>
            </div>
            {/* Payment */}
            <div className="form-section">
              <div className="section-header">
                <h3>Payment</h3>
                <p className="muted">
                  All transactions are secure and encrypted.
                </p>
              </div>

              <div className="payment-options">
                <label className="payment-option">
                  <input
                    type="radio"
                    name="payment_method"
                    value="card"
                    checked={formData.payment_method === "card"}
                    onChange={handleFormChange}
                  />
                  <div className="payment-meta">
                    <strong>Pesapal</strong>
                    <div className="card-logos">
                      <img src="/images/visa.png" alt="visa" />
                      <img src="/images/master.png" alt="master" />
                    </div>
                  </div>
                </label>

                <label className="payment-option">
                  <input
                    type="radio"
                    name="payment_method"
                    value="momo"
                    checked={formData.payment_method === "momo"}
                    onChange={handleFormChange}
                  />
                  <div className="payment-meta">
                    <strong>MTN MOMO</strong>
                    <div className="muted small">Mobile money</div>
                  </div>
                </label>
              </div>

              {/* Conditional helpers */}
              {formData?.payment_method === "card" && (
                <div className="payment-help">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="-270.8 371 102 52"
                    className="payment-svg"
                    aria-hidden
                  >
                    <path
                      fill="none"
                      stroke="currentColor"
                      strokeMiterlimit="10"
                      strokeWidth="2"
                      d="M-182 404v16.8c0 .7-.4 1.2-1 1.2h-75.7c-.7 0-1.2-.6-1.2-1.2v-47.6c0-.7.6-1.2 1.2-1.2h75.7c.7 0 1 .6 1 1.2V395m-78-14h78m-17 18h27m-3.9-4.6 4.5 4.6-4.5 4.6"
                    />
                    <circle
                      cx="-255.5"
                      cy="376.5"
                      r="1.5"
                      fill="currentColor"
                    />
                    <circle
                      cx="-250.5"
                      cy="376.5"
                      r="1.5"
                      fill="currentColor"
                    />
                    <circle
                      cx="-245.5"
                      cy="376.5"
                      r="1.5"
                      fill="currentColor"
                    />
                  </svg>
                  <p>
                    After clicking <strong>Pay now</strong>, you will be
                    redirected to Pesapal to complete your purchase securely.
                  </p>
                </div>
              )}

              {formData.payment_method === "momo" && (
                <label className="input-label">
                  Mobile number for MOMO
                  <input
                    name="phoneNumber"
                    type="text"
                    placeholder="+250 7XXXXXXXX"
                    value={formData?.phoneNumber}
                    onChange={handleFormChange}
                  />
                </label>
              )}

              {formData?.payment_method && (
                <div className="form-actions">
                  <button
                    type="submit"
                    className="submit-btn"
                    disabled={isLoading}
                  >
                    {isLoading
                      ? "Processing..."
                      : formData?.payment_method === "card"
                      ? "Complete order"
                      : "Pay Now"}
                  </button>
                </div>
              )}
            </div>
          </form>
        </section>

        {/* RIGHT: Order summary */}
        <aside className="bone-checkout-summary">
          <h3 className="summary-title">Order summary</h3>

          <div className="summary-items">
            {Data && Data?.length > 0 ? (
              Data?.map((el,index) => (
                <div
                  className="summary-item"
                  key={index}
                >
                  <div className="item-thumb">
                    <img src='/images/acrobat1.jpg' alt={el?.name} />
                  </div>
                  <div className="item-meta">
                    <div className="item-name">{el?.name}</div>
                    <div className="item-qty">Qty: {el?.childCount || 1}</div>
                  </div>
                  <div className="item-price">
                    Rwf {amount}
                  </div>
                </div>
              ))
            ) : (
              <div className="muted">Your cart is empty.</div>
            )}
          </div>

          <div className="summary-totals">
            <div className="tot-row">
              <span>amount</span>
              <span>Rwf {amount}</span>
            </div>
            <div className="tot-row">
              <span>Count</span>
              <span>{membershipPlan?.childCount}</span>
            </div>
            <div className="tot-row">
              <span>Tax (3%)</span>
              <span>
                Rwf{" "}
                {Number(taxAmount || 0).toLocaleString(undefined, {
                  maximumFractionDigits: 0,
                })}
              </span>
            </div>
            <div className="tot-row total">
              <strong>Total</strong>
              <strong>
                Rwf{" "}
                {Number(total || 0).toLocaleString(undefined, {
                  maximumFractionDigits: 0,
                })}
              </strong>
            </div>
          </div>
        </aside>
      </main>
    </div>
  );
};

export default CheckOut;
